import { RiskImpact } from '@/app/components/action-plan/types';
import { formatCancerTypeNameWithCapitalization } from '../types';

export function formatCancerAndOthersNameText(args: {
  reducedRisk: RiskImpact;
  isNonQuantifiable: boolean;
  otherCancers: number;
}) {
  if (args.isNonQuantifiable) {
    return 'Overall';
  }

  const primaryCancerText = formatCancerTypeNameWithCapitalization(args.reducedRisk.cancerType);

  return args.otherCancers === 0 ? primaryCancerText : `${primaryCancerText} + ${args.otherCancers} other cancers`;
}
